<div class="ag-labeled ag-label-align-left ag-text-field ag-input-field" role="presentation">
    <div class="ag-wrapper ag-input-wrapper ag-text-field-input-wrapper" role="presentation">
        <input #filterInput class="ag-input-field-input ag-text-field-input" type="text" autocomplete="off" [attr.aria-label]="ariaLabel" [value]="value" (input)="valueChanged(filterInput.value)">
    </div>
</div>
